import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import {useAppRates} from '@/context/AppRatesContext';
import type {UserType} from '@/types';

import PromoTiersFilters from './PromoTiersFilters';
import PromoTiersTable from './PromoTiersTable';
import useTierList from './useTierList';

interface TierProps {
  target?: UserType;
  /** Test hook prefix; the create action, its form and the table namespace under it. */
  dataCy?: string;
}
const Tierlist = ({target = 'AFRIEX', dataCy}: TierProps) => {
  const {state} = useAppRates();
  const {
    isLoading,
    fetchList,
    pageInfo,
    list,
    isPageReset,
    isSearch,
    selectCurrentFilters,
    currentFilters,
    handleAutoComplete,
    clearFilters,
  } = useTierList(target);

  return (
    <div className="my-5 mx-4 md:mx-10">
      <PromoTiersFilters
        handleAutoComplete={handleAutoComplete}
        currentFilters={currentFilters}
        selectCurrentFilters={selectCurrentFilters}
        clearFilters={clearFilters}
        appRates={state.rawAppRates}
        target={target}
        dataCy={dataCy}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <PromoTiersTable
            items={list}
            rawAppRates={state.rawAppRates}
            dataCy={dataCy}
          />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </div>
  );
};

export default Tierlist;
